import React from 'react';
// @ts-ignore
import styles from './LaboratoryRequestCreateFormItem.module.scss';
import { LaboratoryRequestItem } from '../../Interfaces/LaboratoryRequestItem.intefrace';
import { LaboratoryRequestItemType } from '../../Enums/LaboratoryRequestItemType';
import LaboratoryRequestCreateFormItemChildren from './LaboratoryRequestCreateFormItemChildren';
import LaboratoryRequestCreateFormItemTabContainer from './LaboratoryRequestCreateFormItemTabContainer';
import CheckboxField from '../../../../Components/Form/components/CheckboxField';
import { isArray } from 'lodash';
import InputField from '../../../../Components/Form/components/InputField';
import useLaboratoryRequestStyles from '../../Hooks/useLaboratoryRequestStyles';
import RadioListField from '../../../../Components/Form/components/RadioListField';
import TextAreaField from '../../../../Components/Form/components/TextAreaField';

interface Props {
	item: LaboratoryRequestItem;
	onItemSelect: (item: LaboratoryRequestItem) => void;
}

const LaboratoryRequestCreateFormItem: React.FC<Props> = ({
	item,
	onItemSelect,
}) => {
	const style = useLaboratoryRequestStyles(item);
	const handleChangeCheckbox = () => {
		onItemSelect(item);
	};

	let component = <></>;

	switch (item.type) {
		case LaboratoryRequestItemType.GROUP:
			component = (
				<div className={styles.group}>
					<div
						className={styles.title}
						style={{ borderColor: item.settings?.backgroundColor }}>
						{item.title}
					</div>
					<LaboratoryRequestCreateFormItemChildren
						items={item.children}
						onItemSelect={onItemSelect}
					/>
				</div>
			);
			break;
		case LaboratoryRequestItemType.CONTAINER:
			component = (
				<div className={styles.container} style={style}>
					<LaboratoryRequestCreateFormItemChildren
						items={item.children}
						onItemSelect={onItemSelect}
					/>
				</div>
			);
			break;
		case LaboratoryRequestItemType.TAB_CONTAINER:
			component = (
				<LaboratoryRequestCreateFormItemTabContainer
					items={item.children}
					onItemSelect={onItemSelect}
				/>
			);
			break;
		case LaboratoryRequestItemType.TITLE:
			component = <div className={styles.title}>{item.value}</div>;
			break;
		case LaboratoryRequestItemType.SUB_TITLE:
			component = <div className={styles.subtitle}>{item.value}</div>;
			break;
		case LaboratoryRequestItemType.GROUP_CHECKBOX:
			if (item.value && isArray(item.value)) {
				component = (
					<CheckboxField
						tx={item.title}
						name={item.value.join(';')}
						className={styles.checkbox}
						customOnChange={handleChangeCheckbox}
						description={item.description}
					/>
				);
			}
			break;
		case LaboratoryRequestItemType.CHECKBOX:
			if (item.value && typeof item.value === 'string') {
				component = (
					<CheckboxField
						tx={item.title}
						name={item.value}
						className={styles.checkbox}
						customOnChange={handleChangeCheckbox}
						description={item.description}
					/>
				);
			}
			break;
		case LaboratoryRequestItemType.TEXT_FIELD:
			if (item.value && typeof item.value === 'string') {
				component = (
					<InputField
						name={item.value}
						label={item.title}
						className={styles.textfield}
						hideRequired
					/>
				);
			}
			break;
		case LaboratoryRequestItemType.TEXT_AREA:
			if (item.value && typeof item.value === 'string') {
				component = (
					<TextAreaField
						name={item.value}
						label={item.title}
						className={styles.textfield}
						hideRequired
					/>
				);
			}
			break;
		case LaboratoryRequestItemType.SPACE:
			component = <div className={styles.space} style={style} />;
			break;
		case LaboratoryRequestItemType.RADIO_LIST:
			if (item.value && typeof item.value === 'string' && item.options) {
				component = (
					<RadioListField
						name={item.value}
						label={item.title}
						data={item.options}
						className={styles.checkbox}
						inLine
						hideRequired
					/>
				);
			}
			break;
	}

	return component;
};

export default LaboratoryRequestCreateFormItem;
